<template>
  <div class="mb-3  text-start">
    <div class="row" v-if="!isLogin">

      <div class="col-12 col-md-6">
        <label for="firstName" class="form-label">First Name</label>
        <input type="text" class="form-control" id="firstNameInput" aria-describedby="emailHelp" v-model="firstName">
  
      </div>

      <div class="col-12 col-md-6">
        <label for="lastName" class="form-label">Last Name</label>
        <input type="text" class="form-control" id="lastNameInput" aria-describedby="emailHelp" v-model="lastName">
      </div>
    </div>
    <div class="row">

<div class="col-12 col-md-6">
    <label for="exampleInputEmail1" class="form-label">Email Address</label>
    <input type="email" class="form-control" id="emailInput" aria-describedby="emailHelp" v-model="email">
</div>
<div class="col-12 col-md-6">
    <label for="password" class="form-label">Password</label>
    <input type="password" class="form-control" id="passwordInput" aria-describedby="emailHelp" v-model="password">
  </div>
  </div>
  <button type="submit" class="submit-button btn btn-warning d-block mx-auto mt-3 w-50" @click="this.$emit('submit',email,password,firstName,lastName)" v-if="!isLogin">Create Account</button>
  <button type="submit" class="submit-button btn btn-warning d-block mx-auto mt-3 w-50" @click="this.$emit('submit',email,password,firstName,lastName)" v-else>Login</button>

</div>
</template>

<script>
export default{
    name:"LoginForm",
    data(){
        return{
        email:"",
        password:"",
        firstName:"",
        lastName:""
        }
    },
    props: {
       isLogin:{type: Boolean,
      default: false}
    }

}
</script>

<style scoped>
.submit-button{
  margin: auto;
}
</style>